/**
 * Weirwood
 * Copyright 2019 Baidu Inc. All rights reserved.
 *
 * @file 封装原生对象方法
 * @author zengxiaohui(zengxiaohui@baidu.com)
 */

/**
 * 替换原生方法
 *
 * @param obj 待替换对象，例如 `document`
 * @param name 代替换对象属性，例如 `addEventListener`
 * @param replacement 替换函数，接收源函数，返回新的函数（例如 try/catch 后的函数）
 * @param track 可选，替换记录，便于复原
 */
export function fill(obj: any, name: string, replacement: any, track?: any[]) {
    if (obj == null) {
        return;
    }

    // 原方法
    const orig = obj[name];

    // 替换后的方法
    obj[name] = replacement(orig);

    // 做替换标记
    obj[name].__raven__ = true;

    // 从替换后的方法可以获取原方法
    obj[name].__orig__ = orig;

    // 从原方法附加 __raven_wrapper__ 参数
    orig.__raven_wrapper__ = obj[name];

    // 是否需要记录替换的方法，便于后续复原
    if (track) {
        track.push([obj, name, orig]);
    }

    return obj[name];
}
